import { render, staticRenderFns } from "./ThankYouForRegistering.vue?vue&type=template&id=4611f616&"
import script from "./ThankYouForRegistering.vue?vue&type=script&lang=js&"
export * from "./ThankYouForRegistering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports